import type { SiteApprovalLineMetaData } from '@safetyhub/shared';

interface MetaDiffViewProps {
  current: SiteApprovalLineMetaData;
  base: SiteApprovalLineMetaData;
  label?: string;
}

function isDiff<T>(a: T, b: T): boolean {
  return JSON.stringify(a) !== JSON.stringify(b);
}

function DiffBadge() {
  return (
    <span className="ml-2 text-xs bg-yellow-100 text-yellow-700 px-1.5 py-0.5 rounded">
      변경됨
    </span>
  );
}

export default function MetaDiffView({ current, base, label = '양식 default 대비' }: MetaDiffViewProps) {
  // 현장 override가 양식과 갈라질 수 있는 축은 결재선 구조뿐이다. 한도(`maxAdditionalLines`)·활성
  // (`hasApprovalLinePolicy`)은 양식 단독 권위라 현장 행에 컬럼이 없고 서버가 양식 값으로 채워 주므로
  // base와 항상 같다 — 그 두 diff 행은 원리적으로 뜰 수 없어 두지 않는다.
  // (⚠️ 「자동승인 역할」 diff도 두지 말 것 — 결재 판정이 읽지 않는 스위치라 화면이 거짓 안내를 한다.)
  const linesDiff = isDiff(current.defaultApprovalLine, base.defaultApprovalLine);

  const hasDiff = linesDiff;

  return (
    <div className="text-xs space-y-1">
      <p className="font-medium text-gray-600">{label}</p>
      {!hasDiff && (
        <p className="text-gray-400">변경된 항목 없음 (양식 default와 동일)</p>
      )}
      {linesDiff && (
        <div>
          <span className="text-gray-500">결재 단계 구조 변경됨</span>
          <DiffBadge />
        </div>
      )}
    </div>
  );
}
